import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment-duration-format';

//import update from "immutability-helper";
//import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import TimeClockPermissionContainer from '../../containers/TimeClock/TimeClockPermission';
import DriverReportContainer from '../../containers/Reporting/DriverReports';
import localStorage from '../../libs/localStorage';

//- UI / Form
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';

import FormDatePicker from '../../components/form/FormDatePicker';
// import UserPicker from "../../components/advancedForm/UserPicker";
import FormComponent from '../../components/FormComponent';
import DownloadIcon from '@material-ui/icons/CloudDownload';
// import FormCheckbox from "../../components/form/FormCheckbox";
import SectionHeader from '../../components/SectionHeader';
import EnhancedTable from '../../components/table/EnhancedTable';
import { statuses } from '../../components/FleetCalendar/WorkDayStatuses';
import LocationMultiSelect from '../../components/advancedForm/LocationMultiSelect';

import { pToC, lateToColor, formatPercentage, noNsToColor } from './helper';

const isLocalhost = Boolean(window.location.hostname === 'localhost');

const isWorkingStatusMap = {};
const statusToDisplay = {};
statuses.forEach(({ value, display, isWorking }) => {
	if (isWorking) {
		isWorkingStatusMap[value] = true;
	}
	statusToDisplay[value] = display;
});

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton: {
			marginTop: 20,
			fontSize: 16,
			borderRadius: '100px',
			padding: '13px 45px',
			textTransform: 'uppercase',
			marginRight: 10,
		},
		icon: {
			paddingRight: 5,
		},
		oddRow: {
			backgroundColor: '#f9f9f9',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 20,
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
		button: {
			marginRight: 5,
		},
		eventsContainer: {
			padding: 20,
		},
		eventContainer: {
			borderTop: '1px solid #eee',
			marginTop: 5,
			paddingTop: 5,
		},
		eventNote: {},
		eventDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		removeButton: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		detailLink: {
			textDecoration: 'none',
			fontWeight: 500,
		},
		dateRange: {
			marginRight: 10,
		},
	};
};

let cacheLastRun = {};
function storeKey(key) {
	return `/driverReports-${key}`;
}

class ShiftReports extends FormComponent {
	constructor(props) {
		super(props);

		const dateRange = localStorage.getItem(storeKey('dateRange')) || 'past30';
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);

		this.state = {
			dateRange,
			afterDate,
			beforeDate,
			order: 'asc',
			orderBy: 'clockInDateTime',
			isSearching: false,
			isClockOutEmployeeDialogOpen: false,
			isUpdateEmployeeDialogOpen: false,
			timeClockShiftForClockOut: undefined,
			isRemoveShiftDialogOpen: false,
			timeClockShiftForRemove: undefined,
			locationIds: localStorage.getItem(storeKey('locationIds')) || [1, 2, 3, 4, 5, 6, 7],
			refreshId: 1,
			...cacheLastRun,
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.state.locationIds !== prevState.locationIds) {
			localStorage.setItem(storeKey('locationIds'), this.state.locationIds);
		}
		if (this.state.dateRange !== prevState.dateRange) {
			localStorage.setItem(storeKey('dateRange'), this.state.dateRange);
		}
	}

	getApiParams = () => {
		const { accessToken } = this.props;
		const { shiftForUserIds, locationIds, afterDate, beforeDate } = this.state;

		const params = {
			accessToken,
			shiftForUserIds,
			afterDate: moment(afterDate).format('YYYY-MM-DD'),
			beforeDate: moment(beforeDate).format('YYYY-MM-DD'),
		};

		if (!_.isEmpty(locationIds)) {
			params.locationIds = locationIds;
		}

		return params;
	};

	handleSearch = () => {
		const { showErrors, runDriverReport } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			return showErrors(_.values(formFieldError));
		}

		this.setState({
			isSearching: true,
			refreshId: this.state.refreshId + 1,
			hasResults: false,
		});

		runDriverReport({
			params: this.getApiParams(),
			callback: (err, r) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.formatResults({ apiResults: r });
			},
		});
	};

	formatResults = ({ apiResults }) => {
		const { userMap, classes } = this.props;
		const { driverReportRows } = apiResults;
		const formattedRows = [];
		const totalRow = {
			key: 'totalRow',
			driverDisplay: 'Total',
			percentageWorked: '-',
			daysWorked: 0,
			daysNotWorked: 0,
			late: 0,
		};

		statuses.forEach(({ value }) => {
			totalRow[value] = 0;
		});

		driverReportRows.forEach((driverReportRow) => {
			const {
				userId,
				locationId,
				countByStatus,
				daysWorked,
				daysNotWorked,
				percentageWorked,
			} = driverReportRow;

			const user = userMap[userId] || {
				firstName: 'Missing',
				lastName: userId,
			};
			const driverDisplay = `${user.firstName} ${user.lastName}`;
			const row = {
				key: `user_${userId}`,
				driverDisplay,
				userId,
				daysWorked,
				daysNotWorked,
				percentageWorked,
				percentageWorkedDisplay: formatPercentage(percentageWorked || 0),
				late: countByStatus.late || 0,
			};

			totalRow.daysWorked += daysWorked;
			totalRow.daysNotWorked += daysNotWorked;
			totalRow.late += row.late;

			statuses.forEach(({ value, display, isWorking }) => {
				let count = 0;
				if (countByStatus[value]) {
					count = countByStatus[value];
				}
				row[value] = count;
				totalRow[value] += count;
			});

			const vRgb = pToC(row.percentageWorked);
			const style = {
				textAlign: 'right',
				backgroundColor: vRgb,
				borderRight: '1px solid #666',
			};
			row.percentageWorkedStyle = style;

			const lateStyle = {
				backgroundColor: lateToColor(row.late),
			};
			row.lateStyle = lateStyle;

			if (row.noCallNoShow) {
				row.noCallNoShowStyle = {
					backgroundColor: noNsToColor(row.noCallNoShow),
				};
			}

			const { afterDate, beforeDate } = this.state;
			row.detailDisplay = (
				<Button
					alt="details"
					color="primary"
					variant="outlined"
					className={classes.detailLink}
					//href={`/reports/drivers/details/${userId}/${locationId}/${afterDate}/${beforeDate}`}
					onClick={() => {
						this.props.history.push(
							`/reports/drivers/details/${userId}/${locationId}/${afterDate}/${beforeDate}`
						);
					}}
				>
					Details
				</Button>
			);
			formattedRows.push(row);
		});

		cacheLastRun = { formattedRows, totalRows: [totalRow], hasResults: true, isSearching: false };
		this.setState({ formattedRows, totalRows: [totalRow], hasResults: true, isSearching: false });
	};

	render() {
		const {
			classes,
			permissions,
			//myTimeClockPermissions,
			//myCanViewUserIds,
			// myCanModifyUserIds,
		} = this.props;

		const { hasResults } = this.state;

		if (!permissions || !_.includes(permissions, 'canRunAttendanceReports')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'reporting.driver.run',
			params,
		};

		const domain = isLocalhost ? 'http://localhost:3702' : '';
		const downloadUrl = `${domain}/api?request=${JSON.stringify(request)}`;

		const { dateRange } = this.state;
		let disabled = true;
		if (dateRange === 'custom') {
			disabled = false;
		}

		const isRequired = true;
		return (
			<form>
				<div className={classes.globalMainHeadline}>Driver Attendance Reports</div>
				<Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
					<Grid spacing={2} container>
						<Grid item xs={12} sm={11} md={9}>
							<Grid spacing={2} container>
								<SectionHeader label="User Filter" gridProps={{ md: 12 }} isTop={true} />
								{/*
                <UserPicker
                  {...this.setForm("userIds", "Employees")}
                  helpText={
                    "Only showing employees you have time clock permission for"
                  }
                  userIdsToShow={myCanModifyUserIds}
                  selectMultiple={true}
                  whoToShow={"driversOnly"}
                  //includeHidden={true}
                />

                <Grid item xs={12}>
                  - or -
                </Grid>
                */}

								<LocationMultiSelect {...this.setForm('locationIds', 'Terminals')} />

								<SectionHeader label="Date Filter" gridProps={{ md: 12 }} />

								<Grid item md={12} style={{ display: 'flex' }}>
									{this.renderDateButton('Past 30 days', 'past30')}
									{this.renderDateButton('Past 60 days', 'past60')}
									{this.renderDateButton('Past 90 days', 'past90')}
									{this.renderDateButton('Past 6 months', 'past6Months')}
									{this.renderDateButton('Past year', 'pastYear')}
									{this.renderDateButton('Custom', 'custom')}
								</Grid>

								<FormDatePicker
									{...this.setForm('afterDate', 'Days after this date (start)', isRequired)}
									format={'M/D/YYYY'}
									gridProps={{ md: 6 }}
									disabled={disabled}
								/>

								<FormDatePicker
									{...this.setForm('beforeDate', 'Days before this date (end)', isRequired)}
									format={'M/D/YYYY'}
									gridProps={{ md: 6 }}
									disabled={disabled}
								/>

								<Grid item xs={12} style={{ padding: '20px 0px' }}>
									<div style={{ direction: 'row', display: 'flex' }}>
										<Button
											onClick={this.handleSearch}
											variant="contained"
											color="primary"
											className={classes.submitButton}
											disabled={this.state.isSearching}
											style={{ marginRight: 10 }}
										>
											<SearchIcon className={classes.icon} />
											Run Report
										</Button>

										<a
											href={downloadUrl}
											style={{ textDecoration: 'none', paddingRight: 5 }}
											target="_blank"
											rel="noreferrer noopener"
										>
											<Button variant="contained" color="primary" className={classes.submitButton}>
												<DownloadIcon className={classes.icon} />
												Search & Download Report
											</Button>
										</a>

										{this.state.isSearching && (
											<div className={classes.runningSearch}>
												<CircularProgress />
												<span style={{ paddingLeft: 10 }}>Searching...</span>
											</div>
										)}
									</div>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Paper>

				<Paper className={classes.globalMainPaper}>
					{!hasResults && <div className={classes.resultsHere}>Results here</div>}
					{hasResults && this.renderResults()}
				</Paper>
			</form>
		);
	}

	setDateRange = (dateRange) => {
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);
		if (!afterDate) {
			this.setState({ dateRange });
		} else {
			this.setState({ dateRange, afterDate, beforeDate });
		}
	};

	dateRangeToDates = (dateRange) => {
		if (dateRange === 'past30') {
			return {
				beforeDate: moment().format('YYYY-MM-DD'),
				afterDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'past60') {
			return {
				beforeDate: moment().format('YYYY-MM-DD'),
				afterDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'past90') {
			return {
				beforeDate: moment().format('YYYY-MM-DD'),
				afterDate: moment().subtract(90, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'past6Months') {
			return {
				beforeDate: moment().format('YYYY-MM-DD'),
				afterDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'pastYear') {
			return {
				beforeDate: moment().format('YYYY-MM-DD'),
				afterDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
			};
		} else {
			return {};
		}
	};

	renderDateButton = (label, range) => {
		const { classes } = this.props;
		const { dateRange } = this.state;

		const variant = dateRange === range ? 'contained' : 'outlined';

		return (
			<Button
				className={classes.dateRange}
				variant={variant}
				color="primary"
				onClick={() => {
					this.setDateRange(range);
				}}
			>
				{label}
			</Button>
		);
	};

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order: order, orderBy: orderBy });
	};

	renderResults = () => {
		const { formattedRows, totalRows } = this.state;
		if (!formattedRows) {
			return null;
		}

		const columns = [
			{
				label: 'Driver',
				sortId: 'driverDisplay',
				displayId: 'driverDisplay',
			},
			{
				label: '%Worked',
				sortId: 'percentageWorked',
				displayId: 'percentageWorkedDisplay',
				useStyle: 'percentageWorkedStyle',
			},
			{
				label: 'Days Worked',
				sortId: 'daysWorked',
				displayId: 'daysWorked',
			},
			{
				label: 'Days Off',
				sortId: 'daysNotWorked',
				displayId: 'daysNotWorked',
				padding: 'none',
			},
			{
				label: 'Late',
				sortId: 'late',
				displayId: 'late',
				useStyle: 'lateStyle',
				padding: 'checkbox',
			},
		];

		[
			'extraDay',
			'modifiedDay',
			'swapOn',
			'swapOff',
			'pto',
			'callOut',
			'noCallNoShow',
			'fmla',
			'wc',
			'loa',
		].forEach((status) => {
			const col = {
				label: statusToDisplay[status],
				sortId: status,
				displayId: status,
				padding: 'none',
			};
			if (status === 'noCallNoShow') {
				col.useStyle = 'noCallNoShowStyle';
			}
			columns.push(col);
		});

		columns.push({ label: 'Details', displayId: 'detailDisplay' });

		return (
			<EnhancedTable
				rows={formattedRows}
				totalRows={totalRows}
				columns={columns}
				isDense={true}
				defaultOrderBy={'percentageWorked'}
				defaultOrder={'desc'}
				refreshId={this.state.refreshId}
				makeSticky={true}
			/>
		);
	};
}

ShiftReports.propTypes = {
	runDriverReport: PropTypes.func.isRequired,
	userMap: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	DriverReportContainer,
	TimeClockPermissionContainer,
])(ShiftReports);
